import {Box, Button} from "@mui/material";
import {ReactNode} from "react";

interface Props {
    label: string;
    children: ReactNode;
    onClick: () => void;
    showLabel?: boolean;
}

const TableOverlayActionButton = ({label, children, onClick, showLabel = false}: Props) => (
    <Box
        component="span"
        sx={{
            display: "inline-flex",
            bgcolor: "common.white",
            borderRadius: 1,
            boxShadow: "0 1px 3px rgba(0,0,0,0.12)",
        }}
    >
        <Button
            type="button"
            aria-label={label}
            title={label}
            size="small"
            onPointerDown={event => event.stopPropagation()}
            onClick={onClick}
            sx={{
                width: showLabel ? "auto" : 28,
                minWidth: showLabel ? 0 : 28,
                height: 28,
                px: showLabel ? 1 : 0,
                border: "1px solid",
                borderColor: "divider",
                borderRadius: 1,
                color: "text.primary",
                bgcolor: "common.white",
                gap: 0.5,
                fontSize: 12,
                fontWeight: 500,
                lineHeight: 1,
                textTransform: "none",
                whiteSpace: "nowrap",
                transition: theme => theme.transitions.create(
                    ["border-color", "box-shadow"],
                    {duration: theme.transitions.duration.shorter},
                ),
                "&:hover": {
                    bgcolor: "common.white",
                    borderColor: "primary.main",
                    boxShadow: "0 2px 6px rgba(15, 23, 42, 0.16)",
                },
            }}
        >
            {children}
            {showLabel && label}
        </Button>
    </Box>
);

export default TableOverlayActionButton;
